import React from 'react';

import messages from './messages';

import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { FormattedDate, FormattedMessage } from 'react-intl';
import Table from 'components/Table';
import Button from 'components/forms/Button';
import { Popconfirm } from 'antd';
const { Column } = Table;

const DisplayTable = ({ data = null, fetching = false, onClickEdit = null, onClickDelete = null }) => (
    <Table
        loading={fetching}
        dataSource={data}
        pagination={{
            pageSize: 31,
            hideOnSinglePage: true,
        }}
        rowKey="uuid"
        tableLayout="auto"
        size="small"
        scroll={{ y: 500 }}
    >
        <Column
            title={<FormattedMessage {...messages.stayDateColumnLabel} />}
            width="20%"
            dataIndex="stayDate"
            render={(value) => (
                <FormattedDate value={value} weekday="short" day="2-digit" month="short" year="numeric" />
            )}
        />
        <Column width="60%" title={<FormattedMessage {...messages.noteColumnLabel} />} dataIndex="note" />
        <Column width="10%" title={<FormattedMessage {...messages.priorityColumnLabel} />} dataIndex="priority" />
        <Column
            dataIndex="actions"
            width="10%"
            align="center"
            render={(_value, row) => (
                <>
                    <Button name="editBtn" onClick={() => onClickEdit(row.stayDate)} icon={<EditOutlined />} />

                    <Popconfirm
                        title={<FormattedMessage {...messages.confirmDeletionText} />}
                        okText={<FormattedMessage {...messages.confirmOk} />}
                        cancelText={<FormattedMessage {...messages.confirmCancel} />}
                        onConfirm={() => onClickDelete(row.id)}
                    >
                        <Button name="deleteBtn" icon={<DeleteOutlined />} />
                    </Popconfirm>
                </>
            )}
        />
    </Table>
);

export default DisplayTable;
